import script from "./MiNTNewsListMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./MiNTNewsListMobile.vue?vue&type=script&setup=true&lang=js"

import "./MiNTNewsListMobile.vue?vue&type=style&index=0&id=4fb9fbb7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fb9fbb7"]])

export default __exports__